module.exports = __webpack_public_path__ + "img/ziyouwangguo4.b8d3ebb2.jpg";